import ContactForm from "../../forms/contact-form";

const Contact = () => {
  return (
    <section className="contact">
      <div className="section-wrapper">
        <h1 className="section-mention">Contact Me</h1>
        <hr className="section-hr" />
        <ContactForm />
      </div>
      <div className="bg-filter"></div>
    </section>
  );
};

export default Contact;
